import { useContext } from 'react'
import styled from 'styled-components'
import Accordion from 'react-bootstrap/Accordion'
import AccordionContext from 'react-bootstrap/AccordionContext'
import { colors } from '../../../const/theme'
import { H2 } from '../../../typography/index'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useAccordionButton } from 'react-bootstrap/AccordionButton'
import { getSubjects } from '../../../redux/learn/actions'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { RootState } from '../../../redux/store'

interface LearnWrapperProps {
  isMenuOpen: boolean
}

export const SubjectContainer = styled(Accordion.Body)`
  display: flex;
  flex-direction: row;
  justify-content: left;
  flex-wrap: wrap;
  height: auto;
  @media (max-width: 415px) {
    justify-content: space-between;
  }
`

export const LearnWrapper = styled.div<LearnWrapperProps>`
  //margin: 24px;
  display: flex;
  flex-direction: column;
  background: white;
  @media (max-width: 415px) {
    z-index: ${({ isMenuOpen }) => (isMenuOpen ? '-1' : '0')};
  }
  width: ${({ isMenuOpen }) => (isMenuOpen ? '90%' : '100%')};
`

export const AccordianWrapper = styled(Accordion)`
  margin: 12px auto;
  border-radius: 10px !important; 
`

export const AccordianItem = styled(Accordion.Item)`
  margin: 24px 0;
  border: none;
  background: white;
`

export const AccordianHeader = styled.div`
  align-items: center;
  border-radius: 16px;
  /* background: ${({ theme }) =>
    `linear-gradient(to right, ${theme.table.background} 0%, ${theme.table.secondary} 100%)`}; */
    color: #58035e;
    background-color: #FFFFFF;
  border: 1px solid lightgray;
  height: 50px;
  display: flex;
  box-shadow: 0 5px 12px ${colors.lightGrey};
`

export const CourseTitle = styled(H2)`
  margin: auto 0;
  color: #58035e;
  text-transform: capitalize;
`

export const ChevronWrapper = styled.div`
  float: right;
  margin: auto;
  margin-left: auto;
  margin-right: 16px;
`

export const CustomToogle = ({ eventKey, callback }: any) => {
  const { batchList = [] } = useSelector(
    (state: RootState) => ({
      batchList: state.user?.userInfo?.userDetail?.batchList
    }),
    shallowEqual
  )
  const dispatch = useDispatch()
  const { activeEventKey } = useContext(AccordionContext)
  const isCurrentEventKey = activeEventKey === eventKey

  const decoratedOnClick = useAccordionButton(eventKey, () => {
    const courseId =
      batchList[eventKey]?.additionalCourseId || batchList[eventKey]?.courseId
    dispatch(
      getSubjects({
        courseId: courseId,
        batchId: batchList[eventKey]?.id
      })
    )
    callback && callback(eventKey)
  })

  return (
    <ChevronWrapper role="button" onClick={decoratedOnClick}>
      <FontAwesomeIcon
        icon={
          isCurrentEventKey ? ['fas', 'chevron-down'] : ['fas', 'chevron-up']
        }
        size="lg"
      />
    </ChevronWrapper>
  )
}

export const LearnPageWrapper = styled.div` 
margin-top: 15px;
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 0 12px;
  background: white !important;
  @media (max-width: 415px) {
    width: 98%;
  }
`
